import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class LayerSourcesTranlations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'LayerSourcesTranlations'
  // Define default properties here
  static instanceDefaults () {
    return {
      layerSourceId: null,
      localeId: 1,
      title: '',
    }
  }
}
const servicePath = 'layer-sources-translations'
const servicePlugin = makeServicePlugin({
  Model: LayerSourcesTranlations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
